import Icon from '../components/Icon.vue'

Icon.register({
  'business-time': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M496 224c79.6 0 144 64.4 144 144s-64.4 144-144 144-144-64.4-144-144 64.4-144 144-144zM560 374.3v-12.6c0-5.3-4.4-9.7-9.7-9.7h-38.3v-54.3c0-5.3-4.4-9.7-9.7-9.7h-12.6c-5.3 0-9.7 4.4-9.7 9.7v76.6c0 5.3 4.4 9.7 9.7 9.7h60.6c5.3 0 9.7-4.4 9.7-9.7zM496 192c-37.5 0-72.3 11.9-100.9 32h-395.1v-80c0-25.6 22.4-48 48-48h80v-48c0-25.6 22.4-48 48-48h160c25.6 0 48 22.4 48 48v48h80c25.6 0 48 22.4 48 48v48.8c-5.3-0.5-10.6-0.8-16-0.8zM320 96v-32h-128v32h128zM326.8 320c-4.3 15.3-6.8 31.3-6.8 48 0 28.8 7.1 56 19.4 80h-291.4c-25.6 0-48-22.4-48-48v-144h192v48c0 8.8 7.2 16 16 16h118.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/business-time.js
// module id = 1132
// module chunks = 0